import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function shahkar(token, params) {
    return Api.post(REQUEST_URLS.FIN_CHECK.SHAHKAR, params, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export default shahkar;